module.exports = __webpack_public_path__ + "img/40_38_076_750.5d9cc4c5.jpg";